import {ClipboardService} from "./ClipboardService";
import {convertPaymentType} from "./http/PedidoService";
import PaymentTypeEnum from "../Enum/PaymentTypeEnum";
import {DashboardOperacaoStatusEnum} from "../Enum/DashboardOperacaoStatusEnum";
import OrderStatusEnum from "../Enum/OrderStatusEnum";
import {toLocaleMoney} from "./NumberService";
import { ProductTypesEnum } from "../Enum/ProductTypesEnum";

export const OrderService = () => {
  function mapDashBoardStatusToOrderStatus(dashboardStatus) {
    const { Atrasados, Todos, Concluidos, Cancelados, Rejeitados, EmAndamento } = DashboardOperacaoStatusEnum
    const {
      FinalizadoPelaOrganizacao,
      FinalizadoPeloMotorista,
      FinalizadoPeloAdm,
      FinalizadoPeloFuncionarioUpgas,
      FinalizadoPeloCliente,
      CanceladoPeloMotorista,
      CanceladoPelaOrganizacao,
      CanceladoPeloCliente,
      CanceladoPorTempoExcedido,
      RejeitadoPeloMotorista,
      RejeitadoPelaOrganizacao,
      AceitoPelaOrganizacao,
      AceitoPeloMotorista,
      AceitoPeloAdm,
      AceitoPeloFuncionarioUpgas,
      CanceladoPeloAdm,
      CanceladoPeloFuncionarioUpgas,
      RejeitadoPeloAdm,
      RejeitadoPeloFuncionarioUpgas
    } = OrderStatusEnum

    if (dashboardStatus === Atrasados || dashboardStatus === Todos) {
      return undefined
    }

    if (dashboardStatus === Concluidos) {
      return [FinalizadoPeloMotorista, FinalizadoPelaOrganizacao, FinalizadoPeloAdm, FinalizadoPeloFuncionarioUpgas, FinalizadoPeloCliente]
    }

    if (dashboardStatus === Cancelados) {
      return [CanceladoPeloMotorista, CanceladoPelaOrganizacao, CanceladoPeloCliente, CanceladoPorTempoExcedido, CanceladoPeloAdm, CanceladoPeloFuncionarioUpgas]
    }

    if (dashboardStatus === Rejeitados) {
      return [RejeitadoPeloMotorista, RejeitadoPelaOrganizacao, RejeitadoPeloAdm, RejeitadoPeloFuncionarioUpgas]
    }

    if (dashboardStatus === EmAndamento) {
      return [AceitoPeloMotorista, AceitoPelaOrganizacao, AceitoPeloAdm, AceitoPeloFuncionarioUpgas]
    }

    return [dashboardStatus]
  }

  function getEnumName(enumObj, value) {
    return Object.keys(enumObj).find(key => enumObj[key] === value);
  }

  function copyToClipboard(order) {
    const { customer, estimatedTime, product, products, paymentType, price, discount, priceWithDiscount, customerFiscalNoteDocument, coupon, change, gasDoPovo } = order
    const brand = products[0]?.marca.nome || null;
    const productListText = products.map(product =>
      `${product.quantidade}x ${brand} ${getEnumName(ProductTypesEnum, product.tipo)} - ${toLocaleMoney(product.valor)}`
    ).join("\n");
    const quantity = order.products.reduce((quantity, product) => quantity + product.quantidade, 0)
    const addressText = `${customer.complement ? `📝 Endereço: ${customer.address}\nComplemento: ${customer.complement}` : `📝 Endereço: ${customer.address}`}`
    const couponText = `${coupon ? ` (Cupom: ${coupon.discount})` : ""}`
    //const pricesText = `${quantity}x ${brand} ${product} - ${price}\nDesconto: ${discount}${couponText}\n🝷 Total: ${priceWithDiscount}`
    const pricesText = `${productListText}\nDesconto: ${discount}${couponText}\n🝷 Total: ${priceWithDiscount}`;
    const paymentTypeText = `${paymentType === "Dinheiro" ? `💵 Dinheiro\nTroco: ${change}` : `💳 ${paymentType} ${paymentType === convertPaymentType(PaymentTypeEnum.App) ? "" : "(levar máquina)"}`}`
    const docNF = customerFiscalNoteDocument ? `\n\nDocumento NF: ${customerFiscalNoteDocument}` : "";
    const googleMapsText = "Veja o endereço diretamente no google maps: https://www.google.com/maps?q=" + encodeURIComponent(customer.address);

    const text = `Pedido Upgas - ${customer.name}\n\n${addressText}\n\n❰ Entrega: ${estimatedTime}\n\n${gasDoPovo ? "GÁS DO POVO\n\n" : ""}${pricesText}\n\nForma de pagamento:  ${paymentTypeText}${docNF} \n\n${googleMapsText}`


    ClipboardService().copy(text)
  }

  return { mapDashBoardStatusToOrderStatus,copyToClipboard }
}
